module.exports = __webpack_public_path__ + "static/img/3_1_1_1.5a6ae4d8.jpg";